import { render } from "./prestore.vue?vue&type=template&id=2f918ef0&scoped=true"
import script from "./prestore.vue?vue&type=script&lang=js"
export * from "./prestore.vue?vue&type=script&lang=js"

import "./prestore.vue?vue&type=style&index=0&id=2f918ef0&scoped=true&lang=css"
import "./prestore.vue?vue&type=style&index=1&id=2f918ef0&lang=css"
script.render = render
script.__scopeId = "data-v-2f918ef0"

export default script